// extracted by mini-css-extract-plugin
export default {"box":"CwaTiCntqJgU9eXzGnPh","datePicker":"BAMc34RL89W5VUCM_vrD"};